import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleDown } from '@fortawesome/free-solid-svg-icons'
import { faAngleUp } from '@fortawesome/free-solid-svg-icons'

class RegimenForm extends React.Component {

    constructor(props) {
        super(props);
        this.initialState = {
            isFormShow: true,
            title: ''
        }
        this.state = this.initialState;
    }

    handleShowForm = () => {
        this.setState(this.initialState);
        this.setState({
            isFormShow: !this.state.isFormShow
        });
    }

    handleChange = (e) => {
        this.setState({ [e.target.name]: e.target.value });
    }

    handleSubmit = (e) => {
        e.preventDefault();
        const { title } = this.state;
        this.props.handleSubmit(title);
        this.setState(this.initialState);
    }

    render() {
        const { isFormShow, title } = this.state;
        const textButtom = isFormShow ? 'Ocultar Formulario' : 'Mostrar Formulario';
        const iconButton = isFormShow ? faAngleUp : faAngleDown;

        const isInvalid = title === '';

        return (
            <div>
                <div className="accordion" id="accordionForm">
                    <div className="nav justify-content-end">
                        <button onClick={this.handleShowForm} className="btn btn-dark btn-sm" type="button" data-toggle="collapse" data-target="#formCollapse" aria-expanded="true" aria-controls="offerFormCollapse">
                            {textButtom}
                            <FontAwesomeIcon className="ml-2" icon={iconButton} />
                        </button>
                    </div>
                    <div id="formCollapse" className="collapse show" data-parent="#accordionForm">
                        <div className="pt-2 pl-3 pr-3">
                            <form onSubmit={this.handleSubmit}>
                                <div className="">
                                    <div className="row">
                                        <div className="col col-12 p-2">
                                            <input className="form-control" value={title} type="text" onChange={this.handleChange} name="title" placeholder="Título" />
                                        </div>
                                        <div className="col-12 nav justify-content-end p-2">
                                            <button disabled={isInvalid} type="submit" className="btn btn-success">Guardar</button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

}

export default RegimenForm;